import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente, usuarioPerfilPCP, usuarioPerfilFinanceiro } from '../usuario/usuario-perfil';


/** Acessos permitidos ao lançamento de pedidos */
export const acessosPedido: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente, usuarioPerfilPCP, usuarioPerfilFinanceiro];

@Injectable()
export class CanActivatePedido implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosPedido);
    }
}
